import React from 'react';
import '../../styles/DigitalSignature.css';
import ButtonComponent from '../ButtonComponent';
import { useIntl } from 'react-intl';

interface ViewSignatureProps {
    signature: string;
    onClose: () => void;
    onClear?: () => void;
    isSaved?: boolean;
}

const ViewSignature: React.FC<ViewSignatureProps> = ({ 
    signature, 
    onClose, 
    onClear,
    isSaved = false
}) => {
    const intl = useIntl();

    const handleClearSignature = () => {
        if (onClear) {
            onClear();
        }
    };

    return (
        <div className="signature-container">
            <div className="signature-popup">
                <img src={`data:image/jpeg;base64,${signature}`} alt="Digital Signature" className="signature-image" />
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                    {onClear && isSaved && (
                        <ButtonComponent 
                            className="clear-button" 
                            onClick={handleClearSignature} 
                            text={intl.formatMessage({ id: "DigitalSignature.Clear" }) || "Limpar Assinatura"} 
                        />
                    )}
                    <ButtonComponent className="cancel-button" onClick={onClose} text={intl.formatMessage({ id: "DigitalSignature.Close" })} />
                </div>
            </div>
        </div >
    );
}

export default ViewSignature;
